export enum RESULT_VIEW {
  MAP = 'MAP',
  LIST = 'LIST',
}
